exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.circle[data-v-32e18af3] {\n  width: 2rem;\n  height: 1.2rem;\n  opacity: 0.5;\n  background: #1FDCC6;\n  border-radius: 50%;\n}", ""]);

// exports
